import { Button, Dialog, Typography } from "@mui/material"
import CloseButton from "common/CloseButton"
import { Font } from "components/shopFeatures/wizard/constants"
import styled from "styled-components"

const StyledContainer = styled.div`
  background-color: ${(p) => p.theme.colors.white};
  position: relative;
  text-align: center;
  padding: 20px;
`
const StyledImage = styled.img`
  width: 43px;
  height: 38px;
`
const StyledTitle = styled(Typography).attrs({ variant: "h2" })`
  font-family: ${Font.OENaPro};
  font-size: 24px;
  font-weight: 400;
  line-height: 34px;
  letter-spacing: 0.05em;
  text-align: center;
`
const StyledText = styled(Typography)`
  font-family: ${Font.OENaPro};
  font-size: 16px;
  font-weight: 300;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: center;
  margin-bottom: 16px;
`
const StyledCloseButton = styled(CloseButton)`
  top: 10px;
  right: 5px;
`
const StyledButton = styled(Button)`
  width: 100%;
  background: ${(p) => p.theme.colors.black};

  :hover {
    background: ${(p) => p.theme.colors.steel};
  }
`

const StyledDialog = styled(Dialog)`
  .errorPaper {
    max-width: 328px;
  }
`

type ErrorDialogProps = {
  open: boolean
  onClose: () => void
  message: string | null
}

const ErrorDialog = ({ open, onClose, message }: ErrorDialogProps) => (
  <StyledDialog
    open={open}
    onClose={onClose}
    aria-labelledby="dialog-title"
    aria-describedby="dialog-description"
    classes={{ paper: "errorPaper " }}
  >
    <StyledContainer>
      <StyledCloseButton onClick={onClose} />

      <StyledImage src="/icons/Union.svg" alt="" />

      <StyledTitle id="dialog-title">משהו השתבש בדרך</StyledTitle>

      {message && <StyledText>{message}</StyledText>}

      <StyledText id="dialog-description">
        בבקשה בדקו את הפרטים שהוזנו ונסו שוב.
      </StyledText>

      <StyledButton variant="contained" color="primary" onClick={onClose}>
        חזרה לסליקת כרטיס האשראי
      </StyledButton>
    </StyledContainer>
  </StyledDialog>
)

export default ErrorDialog
